module.exports = __webpack_public_path__ + "static/media/29ADMSPC10.e4a4fad8.jpg";